<template>
  <router-link
    :to="settlementLink"
    :target="openInNewTab ? '_blank' : '_self'"
    :title="trans('settlement.showObjectsInGroup', {group: settlement.month})"
  >
    {{ settlementName }}
  </router-link>
</template>

<script>
import {DateUtils} from '../utils/date-utils';
import {LocaleUtils} from '../utils/locale-utils';

export default {
  name: 'SettlementName',
  mixins: [
    DateUtils,
    LocaleUtils
  ],
  props: {
    settlement: {
      required: true
    },
    openInNewTab: {
      default () {
        return true;
      }
    }
  },
  computed: {
    settlementName() {
      return this.getMonthNameByIndex(this.settlement.month) + ' ' + this.settlement.year;
    },
    settlementLink() {
      return {
        name: 'SettlementDetails',
        params: {
          settlementId: this.settlement.id
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
